// controllers
import Controller from './Controller'
//import MapController from './../controllers/MapController'

export default {
  "main": {
    controller: Controller,
  }
}
